import type { OptionDB } from "@project/emerge";
import { Sides } from "@project/emerge-types";
import { ConnectorCategory } from "../enum/ConnectorType";
import { Covers } from "../enum/Covers";
import { LTProducts } from "../enum/LTProducts";
import type { FlightCaseSettings } from "../interfaces/FlightCaseSettings";
import { createConnectorSet } from "../structure/ConnectorSetInfos";
import { createCoverOptions } from "../structure/RackInterior";
import { FlightCaseDefinition } from "./FlightCaseDefinition";

export class Haube extends FlightCaseDefinition {
  public static getSerializedDefaultVersion(
    optionDb: OptionDB,
  ): FlightCaseSettings {
    const result: FlightCaseSettings =
      FlightCaseDefinition.getSerializedDefaultVersion(optionDb);
    result.type = LTProducts.Haube;
    // result.exteriorOptions.color = OptionDBInstance.getByName(LTCaseUserOption.PanelColor, "Phenol");
    result.exteriorOptions.strength = 6.5;
    result.variableOptions = [
      createConnectorSet(
        optionDb,
        ConnectorCategory.Lock,
        Covers.BASE,
        Sides.LEFT,
        "AH17291S",
      ),
    ];
    result.cuts = [
      {
        offset: 50,
        invertCover: true,
        reference: Sides.BOTTOM,
        groupName: Covers.BASE,
      },
    ];
    result.coverPaddings = createCoverOptions(result.cuts, "1043", "1043");
    return result;
  }
  public isHood = true;
}
